export function IconMagnify() {
	return <i className="fa-solid fa-magnifying-glass me-2" />;
}
